module.exports = __webpack_public_path__ + "download_appstore_pr.svg?9699b3b0dfbdf1350e836783b48dc249";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/download_appstore_pr.svg
// module id = 1115
// module chunks = 33